import { FC } from 'react';
import { SubmitButton, SubmitButtonProps } from 'components/core/button/Button';

import { FooterChildrenWrapper } from './FooterChildrenWrapper';

export const FooterButton: FC<SubmitButtonProps> = props => {
  const { children, ...buttonProps } = props;
  return (
    <FooterChildrenWrapper>
      <SubmitButton {...buttonProps}>{children}</SubmitButton>
    </FooterChildrenWrapper>
  );
};
